import { fmt, pct } from "@h2lca/core";
import type { TooltipContentProps } from "recharts";

/** Recharts 툴팁 , 기본 툴팁의 색,모양 대신 디자인 시스템 판을 쓴다 */
export function ChartTip({ active, payload }: Partial<TooltipContentProps<number, string>>) {
  if (!active || !payload || payload.length === 0) return null;
  const row = payload[0]?.payload as { name?: string; kgCO2eq?: number; share?: number } | undefined;
  if (!row) return null;
  return (
    <div className="chart-tip">
      <p className="font-semibold text-ink">{row.name}</p>
      <p className="font-mono text-ink-muted">
        {fmt(row.kgCO2eq ?? 0)} kgCO2eq{row.share !== undefined && `, ${pct(row.share)}`}
      </p>
    </div>
  );
}
